import { isoZ, z } from 'my-zod'

const availabilityHoldVehicle = z.object({
  id: z.string(),
  assetFamilyId: z.string()
})

const availabilityHold = z.object({
  id: z.string().uuid(),
  outfitterId: z.number(),
  beginDate: isoZ.date(),
  endDate: isoZ.date(),
  startTime: isoZ.time(),
  endTime: isoZ.time(),
  createdDate: isoZ.instant(),
  expirationDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable(),
  vehicles: availabilityHoldVehicle.array().min(1)
})

export const AvailabilityHoldSchemas = {
  availabilityHold
}

export declare namespace AvailabilityHoldSchemas {
  export type availabilityHold = z.infer<typeof availabilityHold>
}
